import * as Yup from 'yup'

export const CarBrandValidation = Yup.object({
    brandName: Yup.string().required('Please enter your car brand name'),
})
